import React from "react";
import { useParams } from "react-router-dom";
import { connect } from "react-redux";

import DashboardUpdate from "../../Components/Layouts/DashboardUpdate";
import AuthorForm from "../../Components/Forms/TestimonialForm";
import { createEntity, updateEntityInfo, setUpdatedRecentlyToFalse } from "../../Redux/TestimonialForm/actions";
import { getEntityById } from "../../Redux/Testimonial/actions";

function Update({useAuth, getEntityById, createEntity, updateEntityInfo, setUpdatedRecentlyToFalse, data, loginData, selectedForm}) {
  let params = useParams();
  return (
    <DashboardUpdate useAuth={useAuth}>
        <AuthorForm
          isUpdateForm
          {...{params, getEntityById, createEntity, updateEntityInfo, setUpdatedRecentlyToFalse, data, loginData, selectedForm}}
        />
    </DashboardUpdate>
  );
}

const mapStateToProps = (state) => {
  return {
    data: state.testimonial,
    loginData: state.loginData,
    selectedForm: state.testimonialForm,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getEntityById: (tokenData, id) => dispatch(getEntityById(tokenData, id)),
    createEntity: (formData, tokenData) => dispatch(createEntity(formData, tokenData)),
    updateEntityInfo: (formData, tokenData, id) => dispatch(updateEntityInfo(formData, tokenData, id)),
    setUpdatedRecentlyToFalse: () => dispatch(setUpdatedRecentlyToFalse()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Update);
